import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=b0840506&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=b0840506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0840506",
  null
  
)

export default component.exports